import {Button, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Dropdown from "../common/Dropdown/Dropdown";
import Checkbox from "../common/Checkbox/Checkbox";
import React, {Component} from "react";
import ProductService from "../services/product-service";
import toastr from "toastr";
import ToastOptions from "../common/toast/toastr-config";
import history from "../history";

class AddProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isDialogLoading: false,
            productType: "API",
            newProduct: {
                name: {
                    value: "",
                    placeholder: "Name",
                    isValid: true,
                    errorMessage: "",
                    validationMessages: {
                        empty: "Required Field"
                    }
                },
                type: {
                    value: "API",
                    label: "-- select type --"
                },
                appName: {
                    value: "",
                    placeholder: "App Name",
                    isValid: true,
                    errorMessage: "",
                    validationMessages: {
                        empty: "Required Field"
                    }
                },
                productTypes: [
                    {
                        value: "API",
                        label: "API"
                    },
                    {
                        value: "USER",
                        label: "USER"
                    }
                ],
                description: {
                    value: "",
                    placeholder: "Description",
                    isValid: true
                },
                serviceCode: {
                    value: "",
                    placeholder: "Service Code",
                    isValid: true,
                    errorMessage: "",
                    validationMessages: {
                        empty: "Required Field"
                    }
                },
            }
        };
    }

    render() {
        return (
            <Modal isOpen={this.props.isCreateProductDialogModalVisible} size="lg">
                {!this.state.isDialogLoading ? (
                        <ModalHeader toggle={this.props.handleCancel}>New Product</ModalHeader>
                    )
                    : <ModalHeader>New Product</ModalHeader>
                }


                <ModalBody>
                    <FormGroup className="custom_form name-container">
                        {this.state.newProduct.name.value !== "" && (
                            <Label
                                for="product_name"
                                className={
                                    !this.state.newProduct.name.isValid ? "invalid" : ""
                                }
                            >
                                Name
                            </Label>
                        )}
                        <Input
                            type="text"
                            name="product_description"
                            id="product_name"
                            placeholder={this.state.newProduct.name.placeholder}
                            value={this.state.newProduct.name.value}
                            onChange={(e) => this.validateName(e)}
                            invalid={!this.state.newProduct.name.isValid}
                            maxLength="40"
                            autoComplete="off"
                        />
                        <FormFeedback>{!this.state.newProduct.name.isValid ? this.state.newProduct.name.errorMessage : ""}</FormFeedback>
                        <span
                            className={!this.state.newProduct.name.isValid ? "products-feedback-invalid" : "products-feedback"}>
                                    {`${this.state.newProduct.name.value !== "" ? this.state.newProduct.name.value.length : 0}/40`}
                                </span>
                    </FormGroup>
                    <FormGroup>
                        <span className="product-id-label">Type</span>
                        <Dropdown
                            options={this.state.newProduct.productTypes.map(s => s.value)}
                            changeSelectedOption={this.onClickChangeNewProductType}
                        />
                    </FormGroup>

                    {!this.state.isUserProduct &&
                    <FormGroup className="custom_form name-container">
                        {this.state.newProduct.serviceCode.value !== "" && (
                            <Label
                                for="product_serviceCode"
                                className={
                                    !this.state.newProduct.serviceCode.isValid ? "invalid" : ""
                                }
                            >
                                Service Code
                            </Label>
                        )}
                        <Input
                            type="text"
                            name="product_serviceCode"
                            id="product_serviceCode"
                            placeholder={this.state.newProduct.serviceCode.placeholder}
                            value={this.state.newProduct.serviceCode.value}
                            onChange={(e) => this.validateServiceCode(e)}
                            invalid={!this.state.newProduct.serviceCode.isValid}
                            maxLength="5"
                            autoComplete="off"
                        />
                        <FormFeedback>{!this.state.newProduct.serviceCode.isValid ? this.state.newProduct.serviceCode.errorMessage : ""}</FormFeedback>
                        <span
                            className={!this.state.newProduct.serviceCode.isValid ? "products-feedback-invalid" : "products-feedback"}>
                                    {`${this.state.newProduct.serviceCode.value !== "" ? this.state.newProduct.serviceCode.value.length : 0}/5`}
                                </span>
                    </FormGroup>
                    }

                    {this.state.isUserProduct &&
                    <FormGroup className="custom_form name-container">
                        {this.state.newProduct.appName.value !== "" && (
                            <Label
                                for="app_key"
                                className={
                                    !this.state.newProduct.appName.isValid ? "invalid" : ""
                                }
                            >
                                App Name
                            </Label>
                        )}
                        <Input
                            type="text"
                            name="app_key"
                            id="app_key"
                            placeholder={this.state.newProduct.appName.placeholder}
                            value={this.state.newProduct.appName.value}
                            onChange={(e) => this.validateAppName(e)}
                            invalid={!this.state.newProduct.appName.isValid}
                            maxLength="32"
                            autoComplete="off"
                        />
                        <FormFeedback>{!this.state.newProduct.appName.isValid ? this.state.newProduct.appName.errorMessage : ""}</FormFeedback>
                        <span
                            className={!this.state.newProduct.appName.isValid ? "products-feedback-invalid" : "products-feedback"}>
                                        {`${this.state.newProduct.appName.value !== "" ? this.state.newProduct.appName.value.length : 0}/40`}
                                    </span>
                    </FormGroup>
                    }

                    <FormGroup className="custom_form description-textarea-container">
                        {this.state.newProduct.description.value !== "" && (
                            <Label
                                for="product_description"
                                className={
                                    !this.state.newProduct.description.isValid ? "invalid" : ""
                                }
                            >
                                Description
                            </Label>
                        )}
                        <Input
                            type="textarea"
                            name="product_description"
                            id="product_description"
                            placeholder={this.state.newProduct.description.placeholder}
                            value={this.state.newProduct.description.value}
                            onChange={(e) => this.validateDescription(e)}
                            invalid={!this.state.newProduct.description.isValid}
                            maxLength="120"
                            autoComplete="off"
                        />
                        <span
                            className={!this.state.newProduct.description.isValid ? "products-feedback-invalid description" : "products-feedback description"}>
                                    {`${this.state.newProduct.description.value !== "" ? this.state.newProduct.description.value.length : 0}/120`}
                                </span>
                    </FormGroup>

                    {this.state.isUserProduct &&
                    <FormGroup className="custom_form name-container tenant-checkbox">
                        <Checkbox
                            id="tenantBased"
                            label="Tenant-Based Product"
                            isChecked={this.state.isTenantBasedChecked}
                            handleChange={() => this.setState({isTenantBasedChecked: !this.state.isTenantBasedChecked})}
                        />
                    </FormGroup>
                    }
                </ModalBody>


                <ModalFooter>
                    <Button
                        color="btn btn-link"
                        onClick={this.props.handleCancel}
                        disabled={this.props.isDialogLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        className="btn btn-success"
                        onClick={() => this.createProduct()}
                        disabled={
                            this.state.isDialogLoading
                            || (this.state.isUserProduct && (!this.state.newProduct.appName.isValid || !this.state.newProduct.name.isValid))
                            || (!this.state.isUserProduct && (!this.state.newProduct.serviceCode.isValid || !this.state.newProduct.name.isValid))
                        }
                    >
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }

    validateName = e => {
        let _product = this.state.newProduct;
        let productName = e.target.value.trim();

        if (productName === "") {
            _product.name.isValid = false;
            _product.name.errorMessage = _product.name.validationMessages.empty;
        } else if (!/^([0-9a-zA-Z \\$.%_-]*)$/.test(productName)) {
            _product.name.isValid = false;
            _product.name.errorMessage = "Name must contains only letters, numbers and special characters: ._\\-$ %";
        } else {
            _product.name.isValid = true;
        }

        _product.name.value = e.target.value;

        this.setState({
            newProduct: _product
        })
    };

    validateServiceCode = e => {
        let _product = this.state.newProduct;
        let serviceCode = e.target.value.trim();

        if (!/^([0-9a-zA-Z]*)$/.test(serviceCode)) {
            _product.serviceCode.isValid = false;
            _product.serviceCode.errorMessage = "Service Code must contains only letters and numbers";
        } else {
            _product.serviceCode.isValid = true;
        }

        _product.serviceCode.value = e.target.value.toUpperCase();

        this.setState({
            newProduct: _product
        })
    };

    validateAppName = e => {
        let _product = this.state.newProduct;
        let appName = e.target.value.trim();

        if (appName === "") {
            _product.appName.isValid = false;
            _product.appName.errorMessage = _product.appName.validationMessages.empty;
        } else if (!/^([0-9a-z._-]*)$/.test(e.target.value)) {
            _product.appName.isValid = false;
            _product.appName.errorMessage = "App Name must contains only lowercase letters, numbers and special characters: ._-";
        } else {
            _product.appName.isValid = true;
        }

        _product.appName.value = e.target.value;

        this.setState({
            newProduct: _product,
        })
    };

    validateDescription = e => {
        let _product = this.state.newProduct;

        _product.description.value = e.target.value;

        this.setState({
            newProduct: _product
        })
    };


    onClickChangeNewProductType = (type) => {
        let _product = this.state.newProduct;
        _product.type = {value: type, label: type};

        this.setState({
            newProduct: _product
        });

        if (type === "USER") {
            this.setState({
                isUserProduct: true, newProduct: {
                    ...this.state.newProduct,
                    serviceCode: {
                        ...this.state.newProduct.serviceCode,
                        value: "",
                        isValid: true,
                        errorMessage: "",
                    }
                }
            });
        } else {
            this.setState({
                isUserProduct: false,
                newProduct: {
                    ...this.state.newProduct,
                    appName: {
                        value: "",
                        placeholder: "App Name",
                        isValid: true,
                        errorMessage: "",
                        validationMessages: {
                            empty: "Required Field"
                        }
                    }
                }
            });
        }
    };


    addProduct = async (isUserProduct) => {
        try {
            let response = {};
            this.setState({isDialogLoading: true});
            let newProduct = {
                name: this.state.newProduct.name.value.trim(),
                type: this.state.newProduct.type.value,
                description: this.state.newProduct.description.value.trim()
            };
            if (!isUserProduct) {
                newProduct.serviceCode = this.state.newProduct.serviceCode.value.trim();
            } else {
                newProduct.appName = this.state.newProduct.appName.value;
                newProduct.appStructure = this.state.isTenantBasedChecked ? "tenant" : "basic";
            }
            response = await ProductService.createProduct(newProduct);
            this.setState({isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.success("The product has been created.");
            history.push(`/products/${response.data.uuid}`);
        } catch (err) {
            this.handleErrors(err);
        }
    }

    createProduct = async () => {
        if (this.state.newProduct.name.value !== "") {
            this.addProduct(this.state.isUserProduct);
        } else {
            this.validateName({target: {value: this.state.newProduct.name.value}});
        }

    };

    handleErrors = error => {
        let errorData = error.response.data;
        let statusCode = errorData.statusCode;
        let name = errorData.name;

        if (name === "Validation Error") {
            let _product = this.state.newProduct;
            if (statusCode === 400) {
                let body = errorData.body;
                body.forEach(fieldError => {
                    let field = fieldError.field;
                    let message = fieldError.message;

                    if (field === "name") {
                        _product.name.isValid = false;
                        _product.name.errorMessage = message;
                    }

                    if (field === "appName") {
                        _product.appName.isValid = false;
                        _product.appName.errorMessage = message;
                    }
                });
            }
            this.setState({newProduct: _product, isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.error(`${errorData.message}.`);
        } else {
            this.setState({isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };


}

export default AddProduct;


// WEBPACK FOOTER //
// ./src/products/addProduct.js